import apiConfig from 'http/services/api.config'
import apiService from 'http/services/api.service'
import { ApiResponse } from 'http/types/api-response'
import { CaptureStatus } from 'domain/capture-status'

class CaptureApiService {
  private readonly baseUrl: string

  constructor() {
    this.baseUrl = apiConfig.endpoints.capture
  }

  /**
   * Current online/offline status of a client's on-premise capture worker (HAIO).
   * Used by the dashboard on initial load; live updates arrive over SignalR.
   */
  public async getCaptureStatus(clientId: string): Promise<CaptureStatus> {
    const response = await apiService.get<ApiResponse<CaptureStatus>>(
      `${this.baseUrl}/${clientId}`
    )
    return response.responseObject
  }
}

export const captureApiService = new CaptureApiService()
export default captureApiService
